export enum Color {
  BACKGROUND = "#171717",
  WARM_GREY = "#9F968E",
  MED_GREY = "#292929",
  ORANGE = "#FF7C1D",
  YELLOW = "#FFD37C",
  WHITE = "#E9E2DB",
}

export const API_URL = "https://szkvjn0so9.execute-api.us-east-1.amazonaws.com";

export const NEW_YORK = [40.712776, -74.005974];
export const DEFAULT_ZOOM = 12;
